// extracted by mini-css-extract-plugin
export default {"form":"styles_form__yV1IA","reset":"styles_reset__VdS4S","okay":"styles_okay__hywIt"};